export default __webpack_public_path__ + "static/media/line-chart.c94ab096.svg";